import React, { Component } from 'react';
import '../componentform.css';
import componentFormService from '../ComponentFormService.js';
import componentMap from '../../../ComponentMap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faInfoCircle, faEdit, faTrashAlt, faEllipsisV, faEye } from '@fortawesome/free-solid-svg-icons';
import ComponentFormPopup from '../ComponentFormPopup';
import AccordionTabForm from './AccordionTabForm';
import DnDAccordionTab from './DnDAccordionTab';
import FakeDnDAccordionTab from './FakeDnDAccordionTab';
import HtmlEditorField from '../../../HtmlEditorField';
import { showNotification } from '../../../StatusNotification';
import { showConfirmation } from '../../../ConfirmationModal';

export class AccordionForm extends Component {
    static displayName = AccordionForm.name;

    constructor(props) {
        super(props);
        this.state = {
            accordion: null,
            accordionTabs: [],
            formType: null,
            pageId: this.props.pageId,
            versionId: this.props.versionId,
            versionStatus: this.props.versionStatus,
            isEditOnly: this.props.isEditOnly != undefined ? this.props.isEditOnly : false,
            isInPopup: this.props.isInPopup != undefined ? this.props.isInPopup : false,
            popup: null,
            reset: false
        };
        this.displayPopup = this.displayPopup.bind(this);
        this.cancelClicked = this.cancelClicked.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.deleteAccordionTab = this.deleteAccordionTab.bind(this);
    }

    componentDidMount() {
        this.getComponentData();
    }

    handleChange = (e) => {
        let newAccordion = this.state.accordion;
        newAccordion[e.target.name] = e.target.value;
        this.setState({ accordion: newAccordion });
    }

    handleSubmit = (e) => {
        e.preventDefault();

        let accordion = this.state.accordion;
        accordion.versionId = this.state.versionId;
        accordion.pageId = this.state.pageId;

        let url = this.state.formType == "Update" ? "UpdateAccordion" : "CreateAccordion";
        fetch('Admin/' + url, {
            method: 'POST',
            body: JSON.stringify(accordion),
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            }
        }).then(
            response => response.json()
        ).then(
            data => {
                if (!isNaN(data)) {
                    if (!this.state.isEditOnly) {
                        var pageComponentId = this.props.pageComponentId != undefined ? this.props.pageComponentId : 0;
                        var isDataSaved = componentFormService.managePageComponent(this.state.pageId, "Accordion", parseInt(data), parseInt(pageComponentId), this.state.versionId, this.state.versionStatus);
                    }

                    this.props.onComponentSaved();
                }
                else {
                    showNotification(data, "error");
                }
            }
        );
    }

    displayPopup = (accordionTabId, formType) => {
        let popupForm = <AccordionTabForm
            componentId={accordionTabId}
            formType={formType}
            pageId={this.state.pageId}
            pageComponentId={this.props.pageComponentId}
            versionStatus={this.state.versionStatus}
            versionId={this.state.versionId}
            onComponentSaved={this.onPopupComponentSaved.bind(this)}
            isEditOnly={true}
            isInPopup={true}
            accordionId={this.state.accordion.id}
        />;

        let popup = <ComponentFormPopup
            popupForm={popupForm}
            cancelClicked={this.cancelClicked.bind(this)}
        />;

        this.setState({
            popup: popup
        });
    }

    onPopupComponentSaved() {
        showNotification("Saved", "success");

        this.setState({
            reset: true,
            popup: null
        });
        this.getComponentData();
    }

    cancelClicked() {
        this.setState({
            popup: null
        });
    }

    async accordionTabOrderUpdate(componentArray) {
        let componentIdsOrdered = [];
        for (var i = 0; i < componentArray.length; i++) {
            componentIdsOrdered.push(parseInt(componentArray[i].id));
        }

        const response = await fetch('Admin/UpdateAccordionTabComponentOrder', {
            method: 'POST',
            body: JSON.stringify({ "accordionTabIds": componentIdsOrdered }),
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            }
        });

        const data = await response.json();

        if (data != "Saved") {
            showNotification(data, "error");
        }
    }

    async deleteAccordionTab(accordionTabId) {
        let confirmDelete = await showConfirmation("Are you sure you want to delete this component and remove all associations to it?");

        if (confirmDelete) {
            const response = await fetch('Admin/DeleteAccordionTab?componentId=' + accordionTabId, {
                method: 'DELETE',
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json'
                }
            });

            const data = await response.json();

            if (data === "Deleted") {
                this.setState({
                    reset: true
                });
                this.getComponentData();
            }
            else {
                showNotification(data, "error");
            }
        }
    }

    render() {
        let deleteButton = this.state.formType == "Update" ? <button className='delete-btn' onClick={this.deleteComponent.bind(this)}>Delete</button> : null;
        if (this.state.isInPopup) {
            deleteButton = null;
        }

        let componentName = null;
        let headerContent = null;
        if (this.state.accordion != null) {
            let accordion = this.state.accordion;

            componentName = accordion.componentName;
            headerContent = accordion.headerContent;
        }

        let mainFormClasses = "tri-grid";
        let sideMenu;
        let addNewAccordionTabButton = null;
        let accordionTabButtons = [];
        if (this.state.formType == "Update") {
            addNewAccordionTabButton = this.state.versionStatus == 'draft' ?
                <button type="button" onClick={this.displayPopup.bind(this, 0, 'Create')} className='side-menu-button'>Add Tab</button> : "";

            for (var i = 0; i < this.state.accordionTabs.length; i++) {
                let accordionTab = this.state.accordionTabs[i];

                let accordionTabKey = "accordionTab" + i;

                let currentComponentManagementBtns = this.state.versionStatus == 'draft' ?
                    <>
                        <button type="button" className='current-component__edit' onClick={this.displayPopup.bind(this, accordionTab.id, 'Update')} aria-label="Edit"><FontAwesomeIcon icon={faEdit} aria-hidden="true" /></button>
                        <button type="button" className='current-component__delete' onClick={this.deleteAccordionTab.bind(this, accordionTab.id)} aria-label="Delete"><FontAwesomeIcon icon={faTrashAlt} aria-hidden="true" /></button>
                    </> :
                    <>
                        <button type="button" className='current-component__view' onClick={this.displayPopup.bind(this, accordionTab.id, 'Update')} aria-label="View"><FontAwesomeIcon icon={faEye} aria-hidden="true" /></button>
                    </>;

                let accordionTabBtnClasses = this.state.versionStatus == 'draft' ? 'sub-component-button' : 'sub-component-button disable-dnd';

                let accordionTabBtn =
                    <div key={accordionTabKey} className={accordionTabBtnClasses}>

                        {accordionTab.componentName}

                        <div className='current-component__manage'>
                            {currentComponentManagementBtns}
                        </div>
                    </div>;

                accordionTabButtons.push({ id: accordionTab.id.toString(), content: accordionTabBtn });
            }

            let accordionTabDnD = (this.state.versionStatus == 'draft') ?
                <DnDAccordionTab items={accordionTabButtons} itemOrderUpdate={this.accordionTabOrderUpdate.bind(this)} /> :
                <FakeDnDAccordionTab items={accordionTabButtons} />;

            if (this.state.reset) {
                accordionTabDnD = "";
            }

            sideMenu = <div className='side-menu' style={{ paddingRight: '0%' }}>
                {addNewAccordionTabButton}
                {accordionTabDnD}
            </div>;
        }
        else {
            mainFormClasses += " dual-grid__1-2";
        }

        let wrapperClasses = this.state.versionStatus == 'draft' ? 'grid-wrapper component-form' : 'grid-wrapper component-form disable-form';
        let editorWrapper = this.state.versionStatus == 'draft' ? 'editor-wrapper' : 'editor-wrapper disable-wrapper';
        return (
            <div className={wrapperClasses}>
                {this.state.popup}

                <form onSubmit={this.handleSubmit}>
                    <div className='dual-grid'>
                        {sideMenu}

                        <div className={mainFormClasses}>
                            <div className='tri-grid__1-3 form-title'>
                                <h2>{componentName} {componentMap.componentTypeDisplay('Accordion')}</h2>
                            </div>

                            <label htmlFor='accordion-componentName'>Component Name:</label>
                            <input id='accordion-componentName' name='componentName' type='text' defaultValue={componentName} onChange={this.handleChange} required maxLength='15' />
                            <div></div>

                            <label>Header: </label>
                            <div className={editorWrapper}>
                                <HtmlEditorField content={headerContent} handleEditorChange={this.handleChange} name='headerContent' returnAsEvent={true} />
                            </div>
                            <div></div>

                            <div className='tri-grid__1-3'>
                                <button type='submit'>Save</button>
                                {deleteButton}
                            </div>
                        </div>
                    </div>
                </form>
            </div>
        );
    }

    async getComponentData() {
        let componentId = (this.props.componentId !== undefined) ? this.props.componentId : 0;
        let formType = this.props.formType !== undefined ? this.props.formType : 'Create';

        const response = await fetch('Admin/GetAccordion?componentId=' + componentId, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            }
        });

        const data = await response.json();

        this.setState({
            accordion: data.accordion,
            accordionTabs: data.accordionTabs,
            formType: formType,
            reset: false,
        });
    }

    async deleteComponent(e) {
        e.preventDefault();
        let confirmDelete = await showConfirmation("Are you sure you want to delete this component and remove all associations to it?");

        if (confirmDelete) {
            const response = await fetch('Admin/DeleteAccordion?componentId=' + this.state.accordion.id, {
                method: 'DELETE',
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json'
                }
            });

            const data = await response.json();

            if (data === "Deleted") {
                this.props.onComponentDeleted();
            }
            else {
                showNotification(data, "error");
            }
        }
    }
}

export default AccordionForm;